import React, { useState, useRef, useEffect } from "react";
import {
  Col,
  Container,
  Form,
  Row,
  Table,
  Button,
  DropdownButton,
  ButtonGroup,
  Dropdown,
  Tabs,
  Tab,
  Modal,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//components
import TableTemplate from "../../Components/TableTemplate/Table";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";

//css
import "./Manage.css";
import "../../Components/Navbar/Navbar.css";
import trash from "../../Assets/Images/trash.png";

import { productsMockData } from "../../Helpers/mockData/mockData";
import {
  createProduct,
  deleteProduct,
  getAllProducts,
  searchProduct,
  updateProducts,
} from "../../Helpers/apiCalls/Manage/Products";
import { getAllItems, searchItem } from "../../Helpers/apiCalls/itemsApi";
import toast from "react-hot-toast";
import { toastStyle, refreshPage, isAdmin } from "../../Helpers/Utils/Common";
import { validateProducts } from "../../Helpers/Validation/Manage/ProductsValidation";
import InputError from "../../Components/InputError/InputError";
import { getAllPriceLevels } from "../../Helpers/apiCalls/Manage/PriceLevels";
import NoDataImg from "../../Assets/Images/no-data-img.png";

export default function Products() {
  let navigate = useNavigate();
  const [inactive, setInactive] = useState(false);
  const [option, setOption] = useState("Select");
  const [isClicked, setIsClicked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [addOn, setAddOn] = useState("");

  const [filterConfig, setFilterConfig] = useState({
    tab: "braddex",
  });
  const handleTabSelect = (tabKey) => {
    setAddOn("");
    setFilterConfig((prev) => {
      return { ...prev, tab: tabKey, is_addon: "", search: "" };
    });
  };

  // MODALS //
  // DELETE
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  // VIEW
  const [showViewProductModal, setShowViewProductModal] = useState(false);
  const handleShowViewProductModal = () => setShowViewProductModal(true);
  const handleCloseViewProductModal = () => setShowViewProductModal(false);

  // EDIT
  const [showEditProductModal, setShowEditProductModal] = useState(false);
  const handleShowEditProductModal = () => setShowEditProductModal(true);
  const handleCloseEditProductModal = () => {
    setShowEditProductModal(false);
  };

  // ADD
  const [showAddProductModal, setShowAddProductModal] = useState(false);
  const handleShowAddProductModal = () => {
    setShowAddProductModal(true);
    setAddTo("braddex");
    setAddProductData({
      max_flavor: 0,
    });
    setPaper([]);
    setPlastic([]);
    setOptionalItems([]);
    setProducts([]);
  };
  const handleCloseAddProductModal = () => {
    setShowAddProductModal(false);
  };
  const [priceLevelsData, setPriceLevelsData] = useState([]);
  const [addTo, setAddTo] = useState("braddex");
  const handleAddSelect = () => {
    setAddTo("braddex");
  };

  // MODAL TABLE
  const [products, setProducts] = useState([]);
  const [paper, setPaper] = useState([]);
  const [plastic, setPlastic] = useState([]);

  const [optionalItems, setOptionalItems] = useState([
    { product_item_id: "", item_id: "", qty: "", unit: "" },
  ]);
  const [file, setFile] = useState([]);
  const [image, setImage] = useState("");

  const [showViewModal, setShowViewModal] = useState(false);
  const handleShowViewModal = () => {
    setShowViewModal(true);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
    setImage("");
  };

  function handleRemoveProduct(id) {
    const rowId = id;
    const newProductList = [...products];
    newProductList.splice(rowId, 1);
    setProducts(newProductList);
  }
  function handleRemovePaper(id) {
    const rowId = id;
    const newProductList = [...paper];
    newProductList.splice(rowId, 1);
    setPaper(newProductList);
  }
  function handleRemovePlastic(id) {
    const rowId = id;
    const newProductList = [...plastic];
    newProductList.splice(rowId, 1);
    setPlastic(newProductList);
  }

  function handleRemoveOptionalItem(id) {
    const rowId = id;
    const newProductList = [...optionalItems];
    newProductList.splice(rowId, 1);
    setOptionalItems(newProductList);
  }

  function AddProductBtn() {
    const newProduct = { name: "", quantity: "", unit: "" };
    setProducts((prevProduct) => [...prevProduct, newProduct]);
  }
  function AddPaperBtn() {
    const newProduct = { name: "", quantity: "", unit: "" };
    setPaper((prevProduct) => [...prevProduct, newProduct]);
  }
  function AddPlasticBtn() {
    const newProduct = { name: "", quantity: "", unit: "" };
    setPlastic((prevProduct) => [...prevProduct, newProduct]);
  }

  function EditProductBtn() {
    const newProduct = { name: "", quantity: "", unit: "" };
    setProducts((prevProduct) => [...prevProduct, newProduct]);
  }

  function AddOptionalItemBtn() {
    const newProduct = { name: "", quantity: "", unit: "" };
    setOptionalItems((prevProduct) => [...prevProduct, newProduct]);
  }

  function getUnits(id) {
    return itemsData.filter((item) => item.id === id);
  }

  function handleProductChange(e, index) {
    const { name, value } = e.target;
    const list = [...products];
    list[index][name] = value;

    if (name === "id") {
      const unit = getUnits(value);
      list[index]["item_id"] = value;
      list[index]["unitList"] = unit[0];
      list[index]["unit"] = unit[0].item_units[0].unit_from;
    }
    setProducts(list);
  }
  function handlePaperChange(e, index) {
    const { name, value } = e.target;
    const list = [...paper];
    list[index][name] = value;

    if (name === "id") {
      const unit = getUnits(value);
      list[index]["item_id"] = value;
      list[index]["unitList"] = unit[0];
      list[index]["unit"] = unit[0].item_units[0].unit_from;
    }
    setPaper(list);
  }
  function handlePlasticChange(e, index) {
    const { name, value } = e.target;
    const list = [...plastic];
    list[index][name] = value;

    if (name === "id") {
      const unit = getUnits(value);
      list[index]["item_id"] = value;
      list[index]["unitList"] = unit[0];
      list[index]["unit"] = unit[0].item_units[0].unit_from;
    }
    setPlastic(list);
  }

  function handleOptionalItemChange(e, index) {
    const { name, value } = e.target;
    const list = [...optionalItems];
    list[index][name] = value;

    if (name === "item_id") {
      const unit = getUnits(value);

      list[index]["unitList"] = unit[0];
      list[index]["unit"] = unit[0].item_units[0].unit_from;
    }
    setOptionalItems(list);
  }

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Quantity</th>
            <th>Unit</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => {
            return (
              <tr>
                <td>
                  <Form.Select
                    name="id"
                    id={product.item_id}
                    value={product.item_id}
                    onChange={(e) => handleProductChange(e, index)}
                  >
                    <option value="">Select</option>
                    {itemsData.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </Form.Select>
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="qty"
                    min="0"
                    value={product.qty}
                    onChange={(e) => handleProductChange(e, index)}
                  />
                </td>
                <td>
                  {showAddProductModal && (
                    <Form.Select
                      name="unit"
                      id={product.id}
                      value={product.unit}
                      onChange={(e) => handleProductChange(e, index)}
                    >
                      <option value="">Select</option>
                      {product?.unitList?.item_units?.map((data) => {
                        return (
                          <option value={data.unit_from}>
                            {data.unit_from}
                          </option>
                        );
                      })}
                    </Form.Select>
                  )}

                  {showEditProductModal && (
                    <Form.Select
                      name="unit"
                      id={product.id}
                      value={product.unit}
                      onChange={(e) => handleProductChange(e, index)}
                    >
                      <option value="">Select</option>
                      <option value={product.unit}>{product.unit}</option>
                    </Form.Select>
                  )}
                </td>
                <td>
                  <div className="align-middle">
                    <img
                      src={trash}
                      alt="delete"
                      onClick={() => handleRemoveProduct(index)}
                      className="cursor-pointer"
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  function renderAddOnTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Ingredient to replace</th>
            <th>New Ingredient</th>
            <th>Quantity</th>
            <th>Unit</th>
          </tr>
        </thead>
        <tbody>
          {optionalItems?.map((product, index) => {
            return (
              <tr>
                <td>
                  <Form.Select
                    name="product_item_id"
                    id={product.product_item_id}
                    value={product.product_item_id}
                    onChange={(e) => handleOptionalItemChange(e, index)}
                  >
                    <option value="">Select</option>
                    {itemsData.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </Form.Select>
                </td>
                <td>
                  <Form.Select
                    name="item_id"
                    id={product.item_id}
                    value={product.item_id}
                    onChange={(e) => handleOptionalItemChange(e, index)}
                  >
                    <option value="">Select</option>
                    {itemsData.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </Form.Select>
                </td>
                <td>
                  <Form.Control
                    type="number"
                    name="qty"
                    min="0"
                    value={product.qty}
                    onChange={(e) => handleOptionalItemChange(e, index)}
                  />
                </td>
                <td>
                  {showAddProductModal && (
                    <Form.Select
                      name="unit"
                      id={product.unit}
                      value={product.unit}
                      onChange={(e) => handleOptionalItemChange(e, index)}
                    >
                      <option value="">Select</option>
                      {product?.unitList?.item_units?.map((data) => {
                        return (
                          <option value={data.unit_from}>
                            {data.unit_from}
                          </option>
                        );
                      })}
                    </Form.Select>
                  )}

                  {showEditProductModal && (
                    <Form.Select
                      name="unit"
                      id={product.unit}
                      value={product.unit}
                      onChange={(e) => handleOptionalItemChange(e, index)}
                    >
                      <option value="">Select</option>
                      <option value={product.unit}>{product.unit}</option>
                    </Form.Select>
                  )}
                </td>
                <td>
                  <div className="align-middle">
                    <img
                      src={trash}
                      alt="delete"
                      onClick={() => handleRemoveOptionalItem(index)}
                      className="cursor-pointer"
                    />
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  function viewTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Name</th>
            <th>Quantity</th>
            <th>Unit</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => {
            return (
              <tr>
                <td>{product.item_name}</td>
                <td>{product.qty}</td>
                <td>{product.unit}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  function viewAddOnTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Ingredient to Replace</th>
            <th>New Ingredient</th>
            <th>Quantity</th>
            <th>Unit</th>
          </tr>
        </thead>
        <tbody>
          {optionalItems?.map((product, index) => {
            return (
              <tr>
                <td>{product.ingredient_to_replace}</td>
                <td>{product.new_ingredient}</td>
                <td>{product.qty}</td>
                <td>{product.unit}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }

  //ERROR HANDLING
  const [isError, setIsError] = useState({
    name: false,
    size: false,
    list: false,
    listInfo: false,
    optionalInfo: false,
  });

  const [isErrorEdit, setIsErrorEdit] = useState({
    name: false,
    size: false,
    list: false,
    listInfo: false,
    optionalInfo: false,
  });

  //API
  const [itemsData, setItemsData] = useState([]);
  const [productsData, setProductsData] = useState([]);
  const [searchProductName, setSearchProductName] = useState("");
  const [selectedRow, setSelectedRow] = useState({
    name: "",
    is_addon: "",
    items: [],
  });
  const [addProductData, setAddProductData] = useState({
    name: "",
    size: "",
    is_addon: "",
    max_flavor: 0,
    price_level_id: [],
    items: [],
    req_product_item_ids: [],
    req_item_ids: [],
    req_units: [],
    req_quantities: [],
  });
  const [editProductData, setEditProductData] = useState({
    id: "",
    name: "",
    size: "",
    is_addon: "",
    max_flavor: 0,
    items: [],
    req_product_item_ids: [],
    req_item_ids: [],
    req_units: [],
    req_quantities: [],
  });

  const handleEditChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "is_addon") {
      if (editProductData.is_addon === 1 || editProductData.is_addon === "1") {
        setEditProductData((prevState) => ({
          ...prevState,
          [name]: 0,
        }));
      } else {
        setEditProductData((prevState) => ({
          ...prevState,
          [name]: 1,
        }));
      }
    } else if (name === "price_level_id") {
      var array = [...priceLevelsData];
      array.map((data) => {
        if (data.id === value) {
          data.is_selected = checked;
        }
      });
      setPriceLevelsData(array);
    } else {
      setEditProductData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleAddChange = (e) => {
    const { name, value, checked } = e.target;

    if (name === "is_addon") {
      if (addProductData.is_addon === 1) {
        setAddProductData((prevState) => ({
          ...prevState,
          [name]: 0,
        }));
      } else {
        setAddProductData((prevState) => ({
          ...prevState,
          [name]: 1,
        }));
      }
    } else if (name === "price_level_id") {
      var array = [...priceLevelsData];
      array.map((data) => {
        if (data.id === value) {
          data.is_selected = checked;
        }
      });
      setPriceLevelsData(array);
    } else {
      setAddProductData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  //DROPDOWN
  function handleSelectChange(e, row) {
    setSelectedRow(row);
    fetchItems();

    setImage(row.image64);

    if (e.target.value === "delete-product") {
      setEditProductData(row);
      handleShowDeleteModal();
    } else if (e.target.value === "edit-product") {
      setEditProductData(row);
      setProducts(row.items);
      setPaper(row.paper_items ? row.paper_items : []);
      setPlastic(row.plastic_items ? row.plastic_items : []);
      setOptionalItems(row.optional_items);
      handleShowEditProductModal();
      setEditProductData(row);
      fetchItems();
    } else if (e.target.value === "view-product") {
      handleShowViewProductModal();
      setProducts(row.items);
      setPaper(row.paper_items ? row.paper_items : []);
      setPlastic(row.plastic_items ? row.plastic_items : []);
      setOptionalItems(row.optional_items);
      setEditProductData(row);
      fetchItems();
    }
  }

  function ActionBtn(row) {
    return (
      <Form.Select
        name="action"
        className="PO-select-action form-select"
        id={row.id}
        onChange={(e) => handleSelectChange(e, row)}
        value={option}
      >
        <option defaulValue selected hidden>
          Select
        </option>
        <option value="view-product" className="color-options">
          View
        </option>
        {isAdmin && (
          <option value="edit-product" className="color-options">
            Edit
          </option>
        )}
        {isAdmin && (
          <option value="delete-product" className="color-red">
            Delete
          </option>
        )}
      </Form.Select>
    );
  }

  //onEdit
  function handleOnEdit() {
    handleCloseViewProductModal();
    handleShowEditProductModal();
  }

  async function fetchAllPriceLevels() {
    setShowLoader(true);

    if (addTo === "braddex" || selectedRow?.type === "braddex") {
      const response = await getAllPriceLevels();
      var result1 = response.data.data.data;
      if (response.data.data) {
        response.data.data.data.map((data) => {
          data.type = "braddex";
          data.is_selected = false;
        });
        setPriceLevelsData(result1);
      }

      var otherData = result1;
      otherData.map((data, index) => {
        selectedRow?.price_levels?.map((price) => {
          if (data.id === price.id) {
            otherData[index]["is_selected"] = true;
          }
        });
        setPriceLevelsData(otherData);
      });
    }

    setShowLoader(false);
  }

  async function fetchItems() {
    setShowLoader(true);
    setItemsData([]);
    // const response = await getAllItems();
    const response = await searchItem({type: "ingredient"});
    console.log(response)
    if (response.data) {
      let result = response.response.data.map((a) => {
          return {
            name: a.name,
            id: a.id,
            item_units: a.item_units,
            type: a.type,
          };
        });
        console.log(result);
      setItemsData(result);
    }

    setShowLoader(false);
  }

  async function fetchProducts() {
    setShowLoader(true);
    setProductsData([]);

    var array = [];
    const response = await getAllProducts(searchProductName, addOn);
    console.log(response)
    if (response) {
      let result = response?.data?.data?.data.map((a) => {
        var info = a;
        info.product_name = a.name;
        var term = a.type || "";
        var splitted = term.split("_");
        var finalTerm = splitted.map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        });
        info.type_name = finalTerm.join(" ");
        return info;
      });
      setProductsData(result);
    } else if (response.error) {
      setProductsData([]);
    }
    setShowLoader(false);
  }

  function handleSetPriceLevel() {
    var otherData = priceLevelsData;
    priceLevelsData.map((data, index) => {
      selectedRow.price_levels?.map((price) => {
        if (data.id === price.id) {
          otherData[index]["is_selected"] = true;
        }
      });
      setPriceLevelsData(otherData);
    });
  }

  async function create() {
    if (validateProducts(addProductData, products, optionalItems, setIsError)) {
      setIsClicked(true);
      if (addTo === "braddex") {
        const response = await createProduct(
          addProductData,
          priceLevelsData,
          products,
          paper,
          plastic,
          optionalItems,
          file
        );
        if (response.data) {
          if (response.data.status === "success") {
            toast.success("Successfully added product!", {
              style: toastStyle(),
            });
            setTimeout(() => {
              refreshPage();
            }, 1000);
          }
        } else {
          toast.error(response.data.message, {
            style: toastStyle(),
          });
        }
      }
    } else {
      toast.error("Please fill in all required fields", {
        style: toastStyle(),
      });
    }
  }

  async function editProduct() {
    if (
      validateProducts(editProductData, products, optionalItems, setIsErrorEdit)
    ) {
      setIsClicked(true);
      const response = await updateProducts(
        editProductData,
        priceLevelsData,
        products,
        paper,
        plastic,
        optionalItems,
        file
      );

      if (response) {
        if (response.data.status === "success") {
          toast.success(response.data.response, {
            style: toastStyle(),
          });
          setTimeout(() => {
            refreshPage();
          }, 1000);
        } else {
          toast.error(response.data.response, {
            style: toastStyle(),
          });
        }
      } else {
        toast.error(response.data.message, {
          style: toastStyle(),
        });
      }
      setIsClicked(false);
    }
  }

  async function del() {
    setIsClicked(true);

    if (selectedRow.type === "braddex") {
      const response = await deleteProduct(selectedRow.id);
      if (response) {
        if (response?.data?.status === "success") {
          toast.success(response.data.response, {
            style: toastStyle(),
          });
          setTimeout(() => refreshPage(), 1000);
        } else {
          toast.error(response.error.data.messages.error, {
            style: toastStyle(),
          });
        }
      }
    }
  }

  function handleOnSearch(e) {
    const { name, value } = e.target;
    setAddOn(value);
  }

  //API CALL
  React.useEffect(() => {
    fetchItems();
    fetchAllPriceLevels();
  }, []);

  React.useEffect(() => {
    fetchItems();
    fetchAllPriceLevels();
  }, [selectedRow]);

  React.useEffect(() => {
    // searchProducts();
    fetchProducts();
  }, [searchProductName, addOn, filterConfig]);

  React.useEffect(() => {
    handleSetPriceLevel();
  }, [productsData, selectedRow]);

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"MANAGE"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-3">
          <Col xs={6}>
            <h1 className="page-title"> PRODUCTS </h1>
          </Col>
          <Col className="d-flex justify-content-end">
            <input
              type="search"
              className="search-bar"
              defaultValue=""
              name="search"
              placeholder="Search name..."
              // onChange={(e) =>
              //     setSearchProductName(e.target.value)
              // }
              onKeyPress={(e) =>
                e.key === ("Enter" || "NumpadEnter") &&
                setSearchProductName(e.target.value)
              }
            ></input>

            <button className="add-btn" onClick={handleShowAddProductModal}>
              Add
            </button>
          </Col>
        </Row>

        {/* TABLE */}
        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          id="products-tabs"
          className="manager-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="braddex" title="All">
            <div>
              <div className="my-2 px-2 PO-filters">
                <Row>
                  <Col className="d-flex justify-content-start mt-2 mb-0">
                    <span className="me-4 align-middle mt-2 ps-label">
                      Filter By:
                    </span>
                    <Form.Select
                      name="is_addon"
                      className="date-filter me-2"
                      onChange={(e) => handleOnSearch(e)}
                    >
                      <option value="" selected>
                        {" "}
                        All{" "}
                      </option>
                      <option value="1"> Add On</option>
                      <option value="0"> Product </option>
                    </Form.Select>
                  </Col>
                  <Col className="d-flex justify-content-end mt-2 mb-0">
                    <button
                      type="button"
                      className="button-warning-fill justify-content-end"
                      onClick={() =>
                        navigate("/products/updatepriority/braddex")
                      }
                    >
                      Update Priority
                    </button>
                  </Col>
                </Row>
              </div>
              <TableTemplate
                tableHeaders={["PRODUCT NAME", "TYPE", "PRIORITY", "ACTIONS"]}
                headerSelector={["product_name", "type_name", "priority"]}
                tableData={productsData}
                showLoader={showLoader}
                ActionBtn={(row) => ActionBtn(row)}
              />
            </div>
          </Tab>
        </Tabs>
      </div>

      {/* MODALS */}
      <DeleteModal
        text="product"
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onDelete={() => del()}
        isClicked={isClicked}
      />
      <AddModal
        title={`PRODUCT`}
        type="product"
        show={showAddProductModal}
        onHide={handleCloseAddProductModal}
        onSave={() => create()}
        isClicked={isClicked}
      >
        <div className="mt-3 ">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              PRODUCT NAME
              <Form.Control
                type="text"
                name="name"
                value={addProductData.name}
                className="nc-modal-custom-input"
                onChange={(e) => handleAddChange(e)}
                required
              />
              <InputError
                isValid={isError.name}
                message={"Product name is required"}
              />
            </Col>
            <Col>
              <Form.Group className="mt-3" controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Add on"
                  name="is_addon"
                  value="1"
                  className="pt-2"
                  onChange={(e) => handleAddChange(e)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="nc-modal-custom-row mt-0">
            <Col>
              <Form.Check
                inline
                label="Dine In"
                name="type"
                value="dine_in"
                type="radio"
                checked={addProductData.type==="dine_in"}
                onClick={(e) => {
                  handleAddChange(e);
                }}
              />
              <Form.Check
                inline
                label="Take out"
                name="type"
                type="radio"
                value="take_out"
                checked={addProductData.type==="take_out"}
                onClick={(e) => {
                  handleAddChange(e);
                }}
              />
            </Col>
          </Row>

          <Row className="nc-modal-custom-row mt-3">
            <Col>PRICE LEVEL</Col>
          </Row>
          <Row className=" mt-0">
            {priceLevelsData.map((data) => {
              return (
                <>
                  <Col xs={3}>
                    <Form.Check
                      inline
                      label={data.name}
                      name="price_level_id"
                      value={data.id}
                      type="checkbox"
                      // defaultChecked
                      onClick={(e) => {
                        handleAddChange(e);
                      }}
                    />
                  </Col>
                </>
              );
            })}
          </Row>
          <Row className="pt-3 mb-2">
            <Col>
              <input
                class="form-control date-filter gotham"
                type="file"
                accept="image/png, image/gif, image/jpeg"
                id="formFileSm"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>INGREDIENT'S LIST</Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <div className="edit-purchased-items">
              {products.length === 0 ? (
                <span>No Ingredients for Products Added!</span>
              ) : (
                renderTable()
              )}
            </div>
          </Row>
          <Row className="pt-3 PO-add-item">
            <InputError
              isValid={isError.list}
              message={
                "There must be at least one ingredient for this product!"
              }
            />
            <InputError
              isValid={isError.listInfo}
              message={
                "Please make sure to fill all inputs for each ingredient added!"
              }
            />
          </Row>
          <Row className="pt-3 PO-add-item">
            <Button type="button" onClick={() => EditProductBtn()}>
              Add Ingredient
            </Button>
          </Row>
          {/* <Row className="nc-modal-custom-row">
                        <Col>PAPER INGREDIENT'S LIST</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {paper?.length === 0 ? (
                                <span>No Paper Ingredients Added!</span>
                            ) : (
                                renderTablePaper()
                            )}
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => AddPaperBtn()}>
                            Add Paper Ingredient
                        </Button>
                    </Row> */}
          {/* <Row className="nc-modal-custom-row">
                        <Col>PLASTIC INGREDIENT'S LIST</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {plastic?.length === 0 ? (
                                <span>No Plastic Ingredients Added!</span>
                            ) : (
                                renderTablePlastic()
                            )}
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => AddPlasticBtn()}>
                            Add Plastic Ingredient
                        </Button>
                    </Row> */}
          {addProductData.is_addon === 1 ? (
            <>
              <Row className="nc-modal-custom-row">
                <Col>Optional Items</Col>
              </Row>
              <Row className="nc-modal-custom-row">
                <div className="edit-purchased-items">
                  {optionalItems?.length === 0 ? (
                    <span>No Optional Items Found!</span>
                  ) : (
                    renderAddOnTable()
                  )}
                </div>
              </Row>
              <Row className="pt-3 PO-add-item">
                <InputError
                  isValid={isError.optionalInfo}
                  message={
                    "Please make sure to fill all inputs for each ingredient added!"
                  }
                />
              </Row>
              <Row className="pt-3 PO-add-item">
                <Button type="button" onClick={() => AddOptionalItemBtn()}>
                  Add Item
                </Button>
              </Row>
            </>
          ) : (
            ""
          )}
        </div>
      </AddModal>
      <EditModal
        title="PRODUCT"
        type="product"
        show={showEditProductModal}
        onHide={handleCloseEditProductModal}
        onSave={() => editProduct()}
        isClicked={isClicked}
      >
        <div className=" mt-3 ">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              PRODUCT NAME
              <Form.Control
                type="text"
                name="name"
                value={editProductData.name}
                className="nc-modal-custom-input"
                onChange={(e) => handleEditChange(e)}
                required
              />
              <InputError
                isValid={isErrorEdit.name}
                message={"Product name is required"}
              />
            </Col>
            <Col>
              <Form.Group className="mt-3" controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Add on"
                  name="is_addon"
                  value="1"
                  className="pt-2"
                  checked={editProductData.is_addon === "1"}
                  onChange={(e) => handleEditChange(e)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              <Form.Check
                inline
                label="Dine In"
                name="type"
                value="dine_in"
                type="radio"
                defaultChecked={editProductData.type === "dine_in"}
                onClick={(e) => {
                  handleEditChange(e);
                }}
              />
              <Form.Check
                inline
                label="Take Out"
                name="type"
                type="radio"
                value="take_out"
                defaultChecked={editProductData.type === "take_out"}
                onClick={(e) => {
                  handleEditChange(e);
                }}
              />

              {/* <Form.Check
                                inline
                                label="Jumbo"
                                name="size"
                                value="Jumbo"
                                type="radio"
                                defaultChecked={ editProductData.size === "Jumbo"}
                                onClick={(e) => {
                                    handleEditChange(e);
                                }}
                            />
                            <Form.Check
                                inline
                                label="Mega"
                                name="size"
                                value="Mega"
                                type="radio"
                                defaultChecked={ editProductData.size === "Mega"}
                                onClick={(e) => {
                                    handleEditChange(e);
                                }}
                            />
                            <Form.Check
                                inline
                                label="Giga"
                                name="size"
                                value="Giga"
                                type="radio"
                                defaultChecked={ editProductData.size === "Giga"}
                                onClick={(e) => {
                                    handleEditChange(e);
                                }}
                            />
                            <Form.Check
                                inline
                                label="Tera"
                                name="size"
                                value="Tera"
                                type="radio"
                                defaultChecked={ editProductData.size === "Tera"}
                                onClick={(e) => {
                                    handleEditChange(e);
                                }}
                            /> */}
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col>PRICE LEVEL</Col>
          </Row>
          <Row className=" mt-0">
            {priceLevelsData.map((data) => {
              return (
                <>
                  <Col xs={3}>
                    <Form.Check
                      inline
                      label={data.name}
                      name="price_level_id"
                      value={data.id}
                      type="checkbox"
                      checked={data.is_selected}
                      onClick={(e) => {
                        handleEditChange(e);
                      }}
                    />
                  </Col>
                </>
              );
            })}
          </Row>
          <Row className="pt-3 mb-2">
            <Col xs={10}>
              <input
                class="form-control date-filter gotham"
                type="file"
                accept="image/png, image/gif, image/jpeg"
                id="formFileSm"
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>INGREDIENT'S LIST</Col>
          </Row>
          <Row className="nc-modal-custom-row">
            <div className="edit-purchased-items">
              {products.length === 0 ? (
                <span>No Ingredients for Products Found!</span>
              ) : (
                renderTable()
              )}
            </div>
          </Row>
          <Row className="pt-3 PO-add-item">
            <InputError
              isValid={isErrorEdit.list}
              message={
                "There must be at least one ingredient for this product!"
              }
            />
            <InputError
              isValid={isErrorEdit.listInfo}
              message={
                "Please make sure to fill all inputs for each ingredient added!"
              }
            />
          </Row>
          <Row className="pt-3 PO-add-item">
            <Button type="button" onClick={() => EditProductBtn()}>
              Add Ingredient
            </Button>
          </Row>
          {/* <Row className="nc-modal-custom-row">
                        <Col>PAPER INGREDIENT'S LIST</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {paper?.length === 0 ? (
                                <span>No Paper Ingredients Found!</span>
                            ) : (
                                renderTablePaper()
                            )}
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => AddPaperBtn()}>
                            Add Paper Ingredient
                        </Button>
                    </Row> */}
          {/* <Row className="nc-modal-custom-row">
                        <Col>PLASTIC INGREDIENT'S LIST</Col>
                    </Row>
                    <Row className="nc-modal-custom-row">
                        <div className="edit-purchased-items">
                            {plastic?.length === 0 ? (
                                <span>No Plastic Ingredients Found!</span>
                            ) : (
                                renderTablePlastic()
                            )}
                        </div>
                    </Row>
                    <Row className="pt-3 PO-add-item">
                        <Button type="button" onClick={() => AddPlasticBtn()}>
                            Add Plastic Ingredient
                        </Button>
                    </Row> */}
          {editProductData.is_addon === 1 ||
          editProductData.is_addon === "1" ? (
            <>
              <Row className="nc-modal-custom-row">
                <Col>Optional Items</Col>
              </Row>
              <Row className="nc-modal-custom-row">
                <div className="edit-purchased-items">
                  {optionalItems?.length === 0 ? (
                    <span>No Optional Items Found!</span>
                  ) : (
                    renderAddOnTable()
                  )}
                </div>
              </Row>
              <Row className="pt-3 PO-add-item">
                <InputError
                  isValid={isErrorEdit.optionalInfo}
                  message={
                    "Please make sure to fill all inputs for each ingredient added!"
                  }
                />
              </Row>
              <Row className="pt-3 PO-add-item">
                <Button type="button" onClick={() => AddOptionalItemBtn()}>
                  Add Item
                </Button>
              </Row>
            </>
          ) : (
            ""
          )}
        </div>
      </EditModal>
      <ViewModal
        withHeader
        title="PRODUCT"
        withButtons
        show={showViewProductModal}
        onHide={handleCloseViewProductModal}
        onEdit={handleOnEdit}
      >
        <div className=" mt-3">
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              PRODUCT NAME
              <Form.Control
                type="text"
                name="ingredient_name"
                value={editProductData.name}
                className="nc-modal-custom-input"
                required
              />
            </Col>
            <Col>
              <Form.Group className="mt-3" controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Add on"
                  className="pt-2"
                  checked={editProductData.is_addon === "1"}
                />
              </Form.Group>
            </Col>
            <Col>
              <button
                className="button-primary"
                onClick={() => handleShowViewModal()}
              >
                View Image
              </button>
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-0">
            <Col>
              <Form.Check
                inline
                label="Dine In"
                name="type"
                value="dine_in"
                type="radio"
                defaultChecked={editProductData.type === "dine_in"}
                disabled
              />
              <Form.Check
                inline
                label="Take Out"
                name="type"
                type="radio"
                value="take_out"
                defaultChecked={editProductData.type === "take_out"}
                disabled
              />
            </Col>
          </Row>
          <Row className="nc-modal-custom-row mt-3">
            <Col>PRICE LEVEL</Col>
          </Row>
          <Row className=" mt-0">
            {priceLevelsData.map((data) => {
              return (
                <>
                  <Col xs={3}>
                    <Form.Check
                      inline
                      label={data.name}
                      name="price_level_id"
                      value={data.id}
                      type="checkbox"
                      checked={data.is_selected}
                      // onClick={(e) => { handleEditChange(e); }}
                    />
                  </Col>
                </>
              );
            })}
          </Row>
          <Row className="nc-modal-custom-row">
            <Col>INGREDIENT'S LIST</Col>
          </Row>
          <Row className="nc-modal-custom-row mt-0">
            <div className="view-table mt-0 ">
              {products.length === 0 ? (
                <span> No Ingredients for Products Found! </span>
              ) : (
                viewTable()
              )}
            </div>
          </Row>
          {/* <Row className="nc-modal-custom-row">
                        <Col>PAPER INGREDIENT'S LIST</Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-0">
                        <div className="view-table mt-0 ">
                            {paper.length === 0 ? (
                                <span>
                                    {" "}
                                    No Paper Ingredients Found!{" "}
                                </span>
                            ) : (
                                viewTablePaper()
                            )}
                        </div>
                    </Row> */}
          {/* <Row className="nc-modal-custom-row">
                        <Col>PLASTIC INGREDIENT'S LIST</Col>
                    </Row>
                    <Row className="nc-modal-custom-row mt-0">
                        <div className="view-table mt-0 ">
                            {plastic.length === 0 ? (
                                <span>
                                    {" "}
                                    No Plastic Ingredients Found!{" "}
                                </span>
                            ) : (
                                viewTablePlastic()
                            )}
                        </div>
                    </Row> */}
          {editProductData.is_addon === 1 ||
          editProductData.is_addon === "1" ? (
            <>
              <Row className="nc-modal-custom-row">
                <Col>OPTIONAL ITEMS</Col>
              </Row>
              <Row className="nc-modal-custom-row mt-0">
                <div className="view-table mt-0 ">
                  {optionalItems.length === 0 ? (
                    <span>No Optional Items Found!</span>
                  ) : (
                    viewAddOnTable()
                  )}
                </div>
              </Row>
            </>
          ) : (
            ""
          )}
        </div>
      </ViewModal>

      <Modal
        show={showViewModal}
        onHide={() => handleCloseViewModal()}
        size="md"
        centered
      >
        <Modal.Body className="pt-5">
          {image !== "" ? (
            <div className="row justify-content-center">
              <div
                className="col-sm-12 align-center"
                style={{ textAlignLast: "center" }}
              >
                <img src={image} width={400} height={400} />
              </div>
            </div>
          ) : (
            <div className="no-data-cont">
              <div
                className="mt-5 mb-2"
                style={{ textAlignLast: "center" }}
                alt="no data found"
              >
                <img src={NoDataImg} width={400} height={400} />
              </div>
              <span>Uh Oh! No data found.</span>
            </div>
          )}

          <div className="d-flex justify-content-center my-4">
            <button
              className="button-secondary"
              onClick={() => handleCloseViewModal()}
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
